import { handleActions } from 'redux-actions';
import {
  createLoadListReducer,
  createLoadListReducerWithBegin, createLoadParameterReducer,
  createOperationStateReducer,
} from '../../utils/getCrudConfig';
import { PARKING_METER_MODULE } from '../../configs/moduleNames';
import {
  HISTORY_EXPORT_WORD,
  HISTORY_POPUP,
  HOST_COMMAND_CANCEL,
  HOST_COMMAND_DISPATCH, HOST_PROBLEMS_DETAIL,
  LOAD_HISTORY_LIST,
  LOAD_HOST_COMPONENTS, LOAD_HOST_DETAIL,
  LOAD_HOST_LIST, LOAD_HOST_STATUSES_HISTORY,
  LOAD_HOST_STATUSES_LIST,
  LOAD_ZONES,
  SET_SERVER_TIME_ZONE,
  LOAD_HOST_PROBLEMS,
} from './actions';
import ParkingMeterDTO from '../../dto/ParkingMeterDTO';
import ListType from '../../dto/converters/ListType';
import { HIDE, SHOW } from '../../configs/actionNames';
import HostCommandDTO from '../../dto/HostCommandDTO';
import HostStatusDTO from '../../dto/HostStatusDTO';
import DtoType from '../../dto/converters/DtoType';
import HostStatusHistoryDTO from '../../dto/HostStatusHistoryDTO';
import HostStatusDetailDTO from '../../dto/HostStatusDetailDTO';

const initialState = {
  loadingHostComponents: false,
  loadingHostList: false,
  hostList: [],
  hostListMeta: {},
  showHistoryPopup: false,
  currentParkingMeter: null,
  loadingHostCommandHistory: false,
  hostCommandHistory: null,
  hostCommandHistoryMeta: {},
  loadingHostCommandDispatch: false,
  loadingHostCommandCancel: false,
  loadingHostStatusesList: false,
  hostStatusesList: [],
  hostStatusesListMeta: {},
  loadingHostDetail: false,
  hostDetail: null,
  loadingHistoryExportWord: false,
  loadingHostStatusesHistoryList: false,
  hostStatusesHistoryList: [],
  hostStatusesHistoryListMeta: {},
  zones: [],
  loadingZones: false,
  loadingHostStatusDetail: false,
  hostStatusDetail: [],
  hostStatusDetailMeta: {},
  serverTimezone: 'Europe/Moscow',
  loadingHostProblems: false,
  hostProblems: [],
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(PARKING_METER_MODULE + LOAD_HOST_LIST, 'hostList', 'loadingHostList'),
  ...createOperationStateReducer(PARKING_METER_MODULE + LOAD_HOST_COMPONENTS, 'loadingHostComponents'),
  ...createOperationStateReducer(PARKING_METER_MODULE + HOST_COMMAND_DISPATCH, 'loadingHostCommandDispatch'),
  ...createOperationStateReducer(PARKING_METER_MODULE + HOST_COMMAND_CANCEL, 'loadingHostCommandCancel'),
  ...createLoadListReducer(PARKING_METER_MODULE + LOAD_HISTORY_LIST, 'hostCommandHistory', 'loadingHostCommandHistory'),
  ...createLoadListReducerWithBegin(PARKING_METER_MODULE + LOAD_HOST_STATUSES_LIST, 'hostStatusesList', 'loadingHostStatusesList'),
  ...createLoadParameterReducer(PARKING_METER_MODULE + LOAD_HOST_DETAIL, 'hostDetail', 'loadingHostDetail', null),
  ...createLoadParameterReducer(PARKING_METER_MODULE + LOAD_ZONES, 'zones', 'loadingZones', []),
  ...createLoadParameterReducer(PARKING_METER_MODULE + SET_SERVER_TIME_ZONE, 'serverTimezone', 'loadingServerTimezone', 'Europe/Moscow'),
  ...createOperationStateReducer(PARKING_METER_MODULE + HISTORY_EXPORT_WORD, 'loadingHistoryExportWord'),
  ...createLoadListReducerWithBegin(PARKING_METER_MODULE + LOAD_HOST_STATUSES_HISTORY, 'hostStatusesHistoryList', 'loadingHostStatusesHistoryList'),
  ...createLoadListReducer(PARKING_METER_MODULE + HOST_PROBLEMS_DETAIL, 'hostStatusDetail', 'loadingHostStatusDetail'),
  ...createLoadListReducer(PARKING_METER_MODULE + LOAD_HOST_PROBLEMS, 'hostProblems', 'loadingHostProblems'),

  [PARKING_METER_MODULE + HISTORY_POPUP + SHOW]: (state, action) => ({
    ...state,
    currentParkingMeter: action.payload,
    showHistoryPopup: true,
  }),
  [PARKING_METER_MODULE + HISTORY_POPUP + HIDE]: state => ({
    ...state,
    currentParkingMeter: null,
    showHistoryPopup: false,
  }),
}, initialState);

export default reducer;

export const getParkingMetersData = state => {
  const reducerData = state[PARKING_METER_MODULE];
  const {
    loadingHostComponents = false,
    loadingHostList = false,
    hostList: list = [],
    hostListMeta = {},
    showHistoryPopup = false,
    currentParkingMeter = null,
    loadingHostCommandHistory = false,
    hostCommandHistory: commandList = null,
    hostCommandHistoryMeta = {},
    loadingHostCommandDispatch = false,
    loadingHostCommandCancel = false,
    loadingHostStatusesList = false,
    hostStatusesList: statusesList = [],
    hostStatusesListMeta = {},
    loadingHostDetail = false,
    hostDetail: hostDetailData = null,
    loadingHistoryExportWord = false,
    loadingHostStatusesHistoryList = false,
    hostStatusesHistoryList: hshList = [],
    hostStatusesHistoryListMeta = {},
    zones = [],
    loadingZones = false,
    loadingHostStatusDetail = false,
    hostStatusDetailMeta = {},
    hostStatusDetail: hsdList = [],
    serverTimezone = '',
    loadingHostProblems = false,
  } = reducerData;
  const hostList = new ListType(ParkingMeterDTO)(list);
  const hostCommandHistory = new ListType(HostCommandDTO)(commandList);
  const hostStatusesList = new ListType(HostStatusDTO)(statusesList);
  const hostStatusesHistoryList = new ListType(HostStatusHistoryDTO)(hshList);
  const hostStatusDetail = new ListType(HostStatusDetailDTO)(hsdList);
  const hostDetail = hostDetailData ? new DtoType(ParkingMeterDTO)(hostDetailData) : null;
  return {
    hostList,
    loadingHostList,
    hostListMeta,
    loadingHostComponents,
    showHistoryPopup,
    currentParkingMeter,
    loadingHostCommandHistory,
    hostCommandHistoryMeta,
    hostCommandHistory,
    loadingHostCommandDispatch,
    loadingHostCommandCancel,
    loadingHostStatusesList,
    hostStatusesList,
    hostStatusesListMeta,
    loadingHostDetail,
    hostDetail,
    loadingHistoryExportWord,
    loadingHostStatusesHistoryList,
    hostStatusesHistoryList,
    hostStatusesHistoryListMeta,
    zones,
    loadingZones,
    loadingHostStatusDetail,
    hostStatusDetailMeta,
    hostStatusDetail,
    serverTimezone,
    loadingHostProblems,
  };
};
